export function reducer(state, action) {
  switch (action.type) {
    case 'ADD':
      return {
        ...state,
        followedBrands: state.followedBrands.concat(
          state.availableBrands.find(
            (brand) => brand.id === action.payload
          ) ?? {
            id: action.payload,
          }
        ),
      };
    case 'REMOVE':
      return {
        ...state,
        followedBrands: state.followedBrands.filter(
          (brand) => brand.id !== action.payload
        ),
      };
    case 'SET':
      return { ...state, followedBrands: action.payload ?? [] };
    case 'SET_AVAILABLE':
      return { ...state, availableBrands: action.payload ?? [] };
    default:
      throw new Error(`Unresolved action type "${action.type}"`);
  }
}
